import React from 'react';
import { useNavigate } from 'react-router-dom';

export const TarjetaPresupuestos_cliente = (props) => {
	/* Destructuring the props object. */
	const {
		imagenPaciente,
		nombrePaciente,
		telefono,
		direccion,
		localidad,
		precio,
		servicio,
		fecha,
		horasMin,
		activarPresupuestos,
		TipoNotificaciones,
		id,
		cancelarServicio,
		eliminarServicio,
		confirmar,
		rechazarServicio,
		nombrePrestador,
		telefonoPaciente,
		fechaPaciente,
		prestadorServicio,
	} = props;

	const navigate = useNavigate()

	return (
		<div className='TarjetaSuperiorPresupuestos-clinete'>
			<div className='TarjetaSuperiorDerPresupuestos'>
				<div className='fotoTarjetaPresupuestos centrador'>
					<img src={imagenPaciente} />
				</div>
				<div className='nombreDescripcionTarjetaPresupuestos'>
					<div className='nombreTarjetaPresupuestos'>
						<h4>{nombrePaciente}</h4>
					</div>
					<div className='descripcionTarjetaPresupuestos'>
						<b>Fecha de nacimento:</b> {fechaPaciente}
					</div>
					<div className='descripcionTarjetaPresupuestos'>
						<b>Teléfono: </b> {telefono}
					</div>
					<div className='descripcionTarjetaPresupuestos'>
						<b>Población: </b> {localidad.nombre}
					</div>
					<div className='descripcionTarjetaPresupuestos'>
						<b>Dirección:</b> {direccion}
					</div>
				</div>
			</div>
			<div className='TarjetaSuperiorIzqPresupuestos'>
				<div className='precioTarjetaPresupuestos'>
					<h4>{servicio}</h4>
				</div>
				<div className='infoTarjetaPresupuestos'>
					<b>Prsestador de Servicios:</b>
					{nombrePrestador}
				</div>
				<div className='infoTarjetaPresupuestos'>
					<b>Precio:</b>
					{precio} €
				</div>
				<div className='infoTarjetaPresupuestos'>
					<b>Fecha:</b>
					{fecha}
				</div>
				<div className='infoTarjetaPresupuestos'>
					<b>Duración:</b>
					{horasMin} minutos
				</div>
			</div>
			<div className='buttons-presupuesto'>
				{TipoNotificaciones[0] === 'buttonNotificacionesActive' ? (
					<div className='contentBodyCancelarPresupuestos'>
						<div
							className='button borrarCuenta'
							onClick={() => cancelarServicio(id)}
						>
							<div>
								<b>Rechazar</b>
							</div>
						</div>
					</div>
				) : TipoNotificaciones[1] === 'buttonNotificacionesActive' ? (
					<div className='buttons-presupuesto' /*contentBodyCancelarPresupuestos'*/>
						<div className='servicio-aceptado'>
							<div>Activado</div>
						</div>
						<div
							className='button borrarCuenta'
							onClick={() => cancelarServicio(id)}
						>
							<div>
								<b>Cancelar</b>
							</div>
						</div>
					</div>
				) : TipoNotificaciones[2] === 'buttonNotificacionesActive' ? (
					<div className='buttons-presupuesto' /*contentBodyCancelarPresupuestos'*/>
						<div className='servicio-pre-confirma'>
							<div>Por confirmar</div>
						</div>
						<div
							className='button borrarCuenta'
							onClick={() => cancelarServicio(id)}
						>
							<div>
								<b>Cancelar</b>
							</div>
						</div>
					</div>
				) : (
					TipoNotificaciones[3] === 'buttonNotificacionesActive' && (
						<>
						<div className='contentBodyCancelarPresupuestos'>
							<div
								className='button borrarCuenta'
								onClick={() => eliminarServicio(id)}
							>
								<div>
									<b>Eliminar</b>
								</div>
							</div>
						</div>
						<div className='contentBodyCancelarPresupuestos'>
						<div
							className='button button-valorar'
							onClick={()=>{navigate('/resenas',{state:{empresa_id:prestadorServicio.id}})}}
						>
							<div>
								<b>Valorar</b>
							</div>
						</div>
					</div>
					</>
					)
				)}
			</div>
		</div>
	);
};
